<template>
  <div class="toast-container" aria-live="polite" aria-atomic="true">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast"
        :class="`toast--${toast.type}`"
        role="status"
      >
        <span class="toast-message">{{ toast.message }}</span>
        <button
          type="button"
          class="toast-dismiss"
          aria-label="Fechar"
          @click="dismiss(toast.id)"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import { useToast } from '@/composables/useToast';

export default {
  name: 'ToastContainer',
  setup() {
    const { toasts, dismiss } = useToast();
    return { toasts, dismiss };
  },
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 80px;
  left: var(--space-md);
  right: var(--space-md);
  max-width: 400px;
  margin: 0 auto;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  pointer-events: none;
}

.toast-container > * {
  pointer-events: auto;
}

.toast {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-md) var(--space-lg);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
}

.toast--success {
  border-left: 4px solid #2e7d32;
}

.toast--error {
  border-left: 4px solid var(--color-error);
}

.toast--info {
  border-left: 4px solid var(--color-accent);
}

.toast-message {
  flex: 1;
  font-size: 0.9rem;
  color: var(--color-text);
}

.toast-dismiss {
  background: none;
  border: none;
  padding: var(--space-xs);
  cursor: pointer;
  color: var(--color-text-muted);
  border-radius: var(--radius-sm);
}

.toast-dismiss:hover {
  color: var(--color-text);
  background: var(--color-accent-soft);
}

.toast-dismiss .material-icons {
  font-size: 20px;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
